import URI from 'urijs';

export function getIsWebsiteSocialPlatform(website: string | undefined) {
  if (!website) {
    return false;
  }
  const site = website.toLowerCase().trim();
  let uri = new URI(site);

  if (!uri.protocol()) {
    uri = new URI(uri.protocol('https').toString());
  }

  const host = uri.hostname();
  return (host && (host.includes('facebook.com') || host.includes('instagram.com') || host.includes('fb.me')));
}
